import React, {Fragment} from 'react';
import {ToastContainer} from "react-toastify";
import {useTranslation} from "next-i18next";
import Head from "next/head";
import styles from "./ProfileColList.module.scss";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ListGroup from "react-bootstrap/ListGroup";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Image from "next/legacy/image";
import {ShimmerCategoryItem, ShimmerCircularImage, ShimmerSimpleGallery, ShimmerThumbnail} from "react-shimmer-effects";
import Link from "next/link";
import Web3 from "web3";
import parse from "html-react-parser";
import InfinitScroll from "react-infinite-scroll-component";

import dynamic from "next/dynamic";
import {nFormatter} from "../../helper/utilityHelper";
import profileImg from '../../public/collection-img.png'
import verifiedIcon from '../../public/img/verifiedIcon.svg'
import copyAddressIcon from '../../public/img/copyAddressIcon.svg'
import polygon from '../../public/img/polygon.svg'
import ethereum from '../../public/img/eth.svg'
import useProfileColList from "./useProfileColList";

const EditPortionProfile = dynamic(() => import('./editPortionProfile'))
const EditIcon = dynamic(() => import('../profile/svg/EditIcon'))
const EditIcon1 = dynamic(() => import('../profile/svg/EditIcon1'))
const CommonFilterHeader = dynamic(() => import('../common/commonFilter/CommonFilterHeader'))
const CommonFilterDesktop = dynamic(() => import('../common/commonFilter/CommonFilterDesktop'))
const Activities = dynamic(() => import('../common/Activities'))
const UpdateColModal = dynamic(() => import('./updateColModal'))
const CommonShare = dynamic(() => import('../common/ShareModal'))
const Share = dynamic(() => import('../../components/itemDetails/svg/Share'))
const NotFoundSection = dynamic(() => import('../../components/NotFoundSection'))
const BidsList = dynamic(() => import('../../components/home/HotBid/Bidslist'))

function ProfileCollectionList(props) {
    const { t } = useTranslation();
    const activitySize = 10;

    const {
        page,
        shareModal,
        setShareModal,
        isFilterOpen,
        setIsFilterOpen,
        nftLoader,
        cAddress,
        cAddress1,
        filterTags,
        category,
        filterStatus,
        collection,
        collectionCreator,
        isPublic,
        coverPhotoLoader,
        totalNft,
        isFull,
        setIsFull,
        isCleared,
        setIsCleared,
        collectionStr,
        previewTextHidden,
        cInnerDetails,
        isEditProfile,
        setIsEditProfile,
        cData,
        cErrors,
        isCImageLoader,
        cImageError,
        cCollectionImage,
        activityLoader,
        activityList,
        activityPage,
        chainIndex,
        viewMoreLoader,
        minClear,
        maxClear,
        key,
        setKey,
        ownedByMe,
        characterSet,
        isEditPortion,
        setIsEditPortion,
        allNftList,
        loadMoreNftActivity,
        changeSearch,
        changePriceSort,
        applyExpiryDates,
        changeOptions,
        changeOwnedOption,
        changeCharacterType,
        applyPrice,
        changeEnsCategory,
        loadMoreNft,
        changeCoverFile,
        savePhoto,
        copyAddress,
        change_c_photo,
        updateCollection,
        c_handleChange,
        validURL,
        refreshMetadata,
        cancelUploadImage,
        clearAllFilters,
        clear_min_max,
        clearFilterTag
    } = useProfileColList(props.currLocale);
    const { isVerified } = props;
    let c_id = "", c_id_sub = "", c_id_slice = "";
    if (collection) {
        if (collection?.collection_id) {
            c_id = collection.collection_id;
            c_id_sub = c_id.substring(1, 8);
            c_id_slice = c_id.slice(-4);
        }
    }
    let pLength, firstString = "", secondString = "";
    if (collectionStr) {
        pLength = collectionStr.length;
        // First String
        let f_str = collectionStr.substring(0, 157);
        let fStr = f_str.split(" ");

        for (let i = 0; i < fStr.length; i++) {
            if (validURL(fStr[i])) {
                firstString += " <a rel='nofollow, noopener' target='_blank' href='" + fStr[i] + "'>" + fStr[i] + "</a>";
            }
            else {
                firstString += " " + fStr[i];
            }
        }

        // Second String
        let s_str = collectionStr;
        let sStr = s_str.split(" ");
        for (let i = 0; i < sStr.length; i++) {
            if (validURL(sStr[i])) {
                secondString += " <a rel='nofollow, noopener' target='_blank' href='" + sStr[i] + "'>" + sStr[i] + "</a>";
            }
            else {
                secondString += " " + sStr[i];
            }
        }
    }

    let tags_array = Object.keys(filterTags).filter(tags => filterTags[tags] || filterTags[tags].length > 0)
    let is_clear_all = tags_array.length > 0
    let currency_symbol = collection?.chainIndex === 2 ? polygon : ethereum

    return (
        <>
            <Head>
                <meta name="robots" content={isVerified ? "index,follow" : "noindex, follow"} />
            </Head>
            {/*<MoralisInstance moralisInstance={(instance) => !callbackInstance && setCallbackInstance(instance) }
                             web3Check={(isEnabled) => setIsWeb3Enabled(isEnabled) }
                             logoutFunc={(logoutProp) => setLogout(logoutProp)} />*/}
            <div className={`${styles.collectionPList}`}>
                <div className={styles.coverPic}>
                    <div className={`${styles.profileHead}`} id="cbgIcon">
                        <Container>
                            {isEditPortion ?
                                <EditPortionProfile changeCoverFile={changeCoverFile}
                                                    cancelUploadImage={cancelUploadImage}
                                                    coverPhotoLoader={coverPhotoLoader}
                                                    savePhoto={savePhoto}
                                                    previewTextHidden={previewTextHidden} />
                                :
                                <>
                                    {!(isPublic || props.cName === "upyo-collection") && (
                                        <div className="d-flex justify-content-end">
                                            <button className={`btn buttonSmall ${styles.profile__button}`}
                                                    onClick={() => setIsEditPortion(true)}>
                                                <span className="me-2">{t('common:edit_cover_photo')}</span>
                                                <EditIcon />
                                            </button>
                                            <button className={`btn buttonSmall ${styles.profile__button}`}
                                                    onClick={() => setIsEditProfile(true)}>
                                                <span className="me-2">{t('common:update_col')}</span>
                                                <EditIcon1 />
                                            </button>
                                        </div>
                                    )}
                                </>
                            }
                        </Container>
                    </div>
                </div>
                <Container>
                    <div className={styles.topDetails}>
                        <div className={`${styles.middleImg}`}>
                            {collection ?
                                <Image src={collection.image_url ? collection.image_url : profileImg}
                                       alt={collection.collection_name ? collection.collection_name + " Collection Image" : " "}
                                       height={112} width={112} layout="responsive" />
                                :
                                <ShimmerCircularImage size={120} />
                            }

                            <h1 className='h4'>
                                {collection?.collection_name ? collection.collection_name : collection.collection_slug}
                                {collection?.isVerified && <Image src={verifiedIcon} width={24} height={24} />}
                            </h1>
                            <div className={`mb-2 ${styles.create} ${styles.userName}`}> {t('common:created_by')}
                                <span>
                                        {(collectionCreator) ?
                                            <Link href={'/nft/profiles/' + (collectionCreator.customUrl ? collectionCreator.customUrl : collectionCreator.walletAddress)}>

                                                    {cAddress1 ? "Copied !" : (collectionCreator.displayName ? collectionCreator.displayName :
                                                            collectionCreator.walletAddress === "0x0000000000000000000000000000000000000000" ? "Unnamed" :
                                                                <>
                                                                    {(collectionCreator.walletAddress).substring(1, 8) + "..." + (collectionCreator.walletAddress).slice(-4)}
                                                                    <Image src={copyAddressIcon} width={16} height={16}
                                                                           onClick={() => copyAddress(collectionCreator.walletAddress,"cAddress1")} />
                                                                </>
                                                    )}
                                            </Link>
                                            : null
                                        }
                                    </span>
                            </div>
                            <div className={`${styles.userName} ${styles.link}`}>
                                {collection && <>
                                    {cAddress ? "Copied !" : c_id_sub + "..." + c_id_slice}
                                    <Image src={copyAddressIcon}
                                           width={16} height={16}
                                           onClick={() => copyAddress(c_id, "cAddress")} />
                                </>}
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.socials}`}>
                        <Link href="#"
                              className={`btn buttonStroke buttonSmall ${styles.user__button}`}
                              onClick={() =>setShareModal(true)} rel="nofollow noopener">
                            <Share />
                        </Link>
                        <CommonShare shareModal={shareModal}
                                     closeShareModal={()=>setShareModal(false)} title="collection" />
                    </div>

                    <div className={`${styles.profileDetail}`}>
                        <div className={`${styles.description} mb-5`} >
                            {cInnerDetails ?
                                <ListGroup className={`${styles.customList}`}>
                                    <ListGroup.Item className={`${styles.cListItem}`}><span>Highest Sale</span>
                                        {
                                            cInnerDetails.highestSale && cInnerDetails.highestSale !== 0 ?
                                                <>
                                                    <Image src={currency_symbol} alt="Ethereum" width={16} height={16} />&nbsp;
                                                    {Web3.utils.fromWei((cInnerDetails.highestSale).toString(), "ether")}
                                                </> : "0"

                                        }
                                    </ListGroup.Item>
                                    <ListGroup.Item className={`${styles.cListItem}`}><span>Floor price</span>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                {cInnerDetails.floorPrice && cInnerDetails.floorPrice !== 0 ?
                                                    <><Image src={currency_symbol} alt="Ethereum" width={16} height={16} />&nbsp;
                                                        {nFormatter(cInnerDetails.floorPrice, 'floorPrice')}
                                                    </>
                                                    : "0"}
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={`${styles.cListItem}`}><span>Market Cap</span>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            {cInnerDetails.marketCap && cInnerDetails.marketCap !== 0 ?
                                                <>
                                                    <Image src={currency_symbol}
                                                           alt="Ethereum"
                                                           width={16} height={16} />&nbsp;
                                                    {nFormatter(cInnerDetails.marketCap, 'marketCap')}
                                                </> : "0"}
                                        </div>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={`${styles.cListItem}`}><span>Items</span>
                                        {cInnerDetails.totalNfts ? nFormatter(cInnerDetails.totalNfts, 'totalNfts') : "0"}
                                    </ListGroup.Item>
                                    <ListGroup.Item className={`${styles.cListItem}`}><span>Owners</span>
                                        {cInnerDetails.totalNoOfOwners ? nFormatter(cInnerDetails.totalNoOfOwners, 'totalNoOfOwners') : "0"}
                                    </ListGroup.Item>
                                    <ListGroup.Item className={`${styles.cListItem}`}><span>Total Volume</span>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            {cInnerDetails.totalVolume && cInnerDetails.totalVolume !== 0 ?
                                                <>
                                                    <Image src={currency_symbol} alt="Ethereum" width={16} height={16} />&nbsp;
                                                    {nFormatter(cInnerDetails.totalVolume, 'totalVolume')}
                                                </>
                                                : "0"}
                                        </div>
                                    </ListGroup.Item>
                                </ListGroup> :
                                <ShimmerSimpleGallery imageHeight={70} row={1} col={4} gap={30} />
                            }

                            <div className={styles.text}>

                                {isFull ?
                                    <>
                                        <p>{parse(firstString)}
                                            <span className={styles.show}
                                                  onClick={()=> setIsFull(false)}>
                                            {t("common:show_more")}
                                            </span>
                                        </p>
                                    </> :
                                    pLength && pLength > 157 ?
                                        <>
                                            <p className={styles.textShow}>
                                                {parse(secondString)}
                                                <span className={styles.show}
                                                      onClick={()=>setIsFull(true)}>
                                                    {t("common:show_less")}
                                                </span>
                                            </p>
                                        </>
                                        :
                                        <p>{parse(firstString)}</p>
                                }
                            </div>

                        </div>

                        {/* Tabs */}
                        <div className={`${styles.listTab} customBTab lightTab`}>
                            <Tabs defaultActiveKey={key} transition={true}
                                  onSelect={(selectedKey) => setKey(selectedKey)}>
                                <Tab eventKey="Items" title={t('common:items')}>
                                    <CommonFilterHeader
                                        changeSearch={changeSearch}
                                        changePriceSort={changePriceSort}
                                        // search={search}
                                        isOpen={isFilterOpen}
                                        onFilterClick={() => setIsFilterOpen(!isFilterOpen)}
                                    />
                                    <div className={styles.catalog_row}>
                                        <div className={styles.catalog_wrapper}>
                                            <CommonFilterDesktop
                                                currLocale={props.currLocale}
                                                applyPrice={applyPrice}
                                                clear_min_max={clear_min_max}
                                                min_clear={minClear}
                                                max_clear={maxClear}
                                                changeOptions={changeOptions}
                                                //isExpiryFilterCleared = {this.state.isExpiryFilterCleared}
                                                applyExpiryDates={applyExpiryDates}
                                                // categoryList={categoryList}
                                                isOpen={false}
                                                changePriceSort={changePriceSort}
                                                isSortingShow={true}
                                                isFire={false}
                                                chainIndex={chainIndex}
                                                category={category}
                                                status={filterStatus}
                                                changeEnsCategory={changeEnsCategory}
                                                isCategoryShow={!!(collection && collection.collection_id === '0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85')}
                                                clearAllFilters={clearAllFilters}
                                                is_cleared = {isCleared}
                                                updateCleared = {()=>setIsCleared(false)}
                                                ownedStatus = {changeOwnedOption}
                                                ownedByMe={ownedByMe}
                                                collectionFilterNeeded = {false}
                                                changeCharacterType={changeCharacterType}
                                                characterSet={characterSet}
                                            />

                                            <div className={`${styles.grids} ${styles.NfTRow}`} id="nftListCollection">
                                                <div className={`d-flex justify-content-between ${styles.slcttFilter}`}>
                                                    <div className={`d-none d-md-block ${styles.clsValue}`}>
                                                        {filterTags && Object.keys(filterTags).map(tag => {
                                                            if (filterTags[tag]) {
                                                                return <>
                                                                        <span className={styles.clFilter}>
                                                                            {filterTags[tag]}
                                                                            <svg onClick={(e) => clearFilterTag(tag)} width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 7.33399L1.33203 0.666015" strokeWidth="1.3" strokeLinecap="round"></path><path d="M1.33203 7.33399L8 0.666016" strokeWidth="1.3" strokeLinecap="round"></path></svg>
                                                                        </span>
                                                                </>
                                                            }
                                                        })}

                                                        <span className={styles.clrall} onClick={clearAllFilters}>
                                                                {is_clear_all ? "Clear all" : ""}
                                                            </span>
                                                    </div>
                                                    {nftLoader && <ShimmerThumbnail height={35} width ={100} />  }
                                                    {!nftLoader &&
                                                    (filterTags?.category1 === "" &&
                                                        filterTags?.category2 === "" &&
                                                        filterTags?.category3 === "" &&
                                                        filterTags?.category4 === "" &&
                                                        filterTags?.category5 === "" &&
                                                        filterTags?.expiryDate === "" &&
                                                        filterTags?.characterSet === "" &&
                                                        !filterTags?.ownedByMe &&
                                                        filterTags?.price === "") ? <div className={styles.totalItem}>{totalNft} {t('common:items')}</div> : <Fragment />
                                                    }

                                                </div>
                                                {nftLoader ?
                                                    <div className='mt-4'>
                                                        <ShimmerSimpleGallery imageHeight={260}
                                                                              row={2}
                                                                              col={isFilterOpen ? 3 : 4}
                                                                              gap={20} caption />
                                                    </div>
                                                    :
                                                    allNftList && allNftList.length > 0 ?
                                                        <>
                                                            <InfinitScroll
                                                                dataLength={allNftList.length}
                                                                next={loadMoreNft}
                                                                hasMore={page !== 1}
                                                                scrollThreshold={0.5}
                                                                className='overflow-hidden'
                                                            >
                                                                <Row>
                                                                    {allNftList.map((info, idx) => {
                                                                        return (
                                                                            <Col xl={3} md={4} xs={6}
                                                                                 className={styles.nftGrd} key={idx}>

                                                                                <BidsList
                                                                                    id={info._id ? info._id : ""}
                                                                                    nftId={info.nft_id}
                                                                                    signature={info.signature}
                                                                                    put_on_sale={info.put_on_sale}
                                                                                    imgURL={(!info.imageUrl || info.imageUrl.length < 1) ? info.imageIPFS : info.imageUrl}
                                                                                    imageIPFS={info.imageIPFS}
                                                                                    is_image_loader={false}
                                                                                    walletAddress={info.walletAddress}
                                                                                    owner={info.owner}
                                                                                    title={info.itemName}
                                                                                    price={info.price}
                                                                                    collection_id={info.collection_id}
                                                                                    auctionType={info.auctionType}
                                                                                    tokenId={info.nft_id}
                                                                                    tokenQty={info.tokenQty}
                                                                                    closingTime={info.closingTime}
                                                                                    highestBidder={info.highestBidder}
                                                                                    currentBid={info.currentBid ? info.currentBid : 0}
                                                                                    is_lazy_mint={info.is_lazy_mint ? info.is_lazy_mint : false}
                                                                                    royalty={info.royalty ? info.royalty : 0}
                                                                                    jsonIpfs={info.jsonIpfs}
                                                                                    user={info.user && info.user}
                                                                                    is_multiple={!!(info.is_multiple && info.is_multiple)}
                                                                                    ownerList={info.ownerList}
                                                                                    nftUsdPrice={info.nftUsdPrice ? info.nftUsdPrice : 0}
                                                                                    favoriteNFT={info.favoriteNFT && info.favoriteNFT ? info.favoriteNFT : {}}
                                                                                    refreshMetadata={refreshMetadata}
                                                                                    chainIndex={info.chainIndex ? info.chainIndex : 1}
                                                                                    i={idx}
                                                                                />
                                                                            </Col>
                                                                        )
                                                                    })}
                                                                </Row>
                                                            </InfinitScroll>
                                                            {viewMoreLoader ?
                                                                <div className='mt-4'>
                                                                    <ShimmerSimpleGallery imageHeight={260}
                                                                                          row={2}
                                                                                          col={isFilterOpen ? 3 : 4}
                                                                                          gap={20} caption />
                                                                </div> :
                                                                null}
                                                        </>
                                                        :
                                                        <>
                                                            <NotFoundSection type="collection" />
                                                        </>
                                                }

                                                {
                                                    page === 1 &&
                                                        <div className="text-center mt-3"
                                                             onClick={loadMoreNft}>
                                                            <div className={`btn buttonStroke loadmoreBtn`}>
                                                                {t('common:view_more')}
                                                            </div>
                                                        </div>
                                                 }
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="Activity" title={t('common:activity')}>
                                    {activityPage === 1 && activityLoader ?
                                        <>
                                            <ShimmerCategoryItem hasImage imageType="circular" imageWidth={100} imageHeight={100} text cta />
                                            <ShimmerCategoryItem hasImage imageType="circular" imageWidth={100} imageHeight={100} text cta />
                                            <ShimmerCategoryItem hasImage imageType="circular" imageWidth={100} imageHeight={100} text cta />
                                        </> :
                                        <>
                                            <InfinitScroll
                                                dataLength={activityList.length}
                                                next={loadMoreNftActivity}
                                                hasMore={true}
                                                scrollThreshold={0.5}
                                                className='overflow-hidden'>
                                                {
                                                    collectionCreator && activityList && activityList.length > 0 ?
                                                        activityList.map((item, idx) => (
                                                            <Activities item={item} key={idx}
                                                                        user={collectionCreator} />
                                                        ))
                                                        :
                                                        <NotFoundSection type="activity-collection" />
                                                }
                                            </InfinitScroll>
                                            {activityLoader && <>
                                                <ShimmerCategoryItem hasImage imageType="circular"
                                                                     imageWidth={100}
                                                                     imageHeight={100}
                                                                     text cta />
                                                <ShimmerCategoryItem hasImage imageType="circular"
                                                                     imageWidth={100}
                                                                     imageHeight={100}
                                                                     text cta />
                                                <ShimmerCategoryItem hasImage imageType="circular"
                                                                     imageWidth={100}
                                                                     imageHeight={100}
                                                                     text cta />
                                            </>
                                            }
                                        </>
                                    }
                                    {(activityList.length < activitySize || activityList.length === 0) ?
                                        null :
                                        activityPage === 1 &&
                                        <div className="text-center" onClick={loadMoreNftActivity}>
                                            <div className={`btn buttonStroke loadmoreBtn`}>
                                                {t('common:view_more')}
                                            </div>
                                        </div>
                                    }
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </Container>

                <ToastContainer autoClose={5000} />

                {isEditProfile && <UpdateColModal is_cImage_loader = {isCImageLoader}
                                                             c_collection_image = {cCollectionImage}
                                                             onHide={() => setIsEditProfile(false)}
                                                             disabled={isCImageLoader}
                                                             onUpdateCollection={updateCollection}
                                                             c_errors={cErrors}
                                                             cImageError={cImageError}
                                                             c_data={cData}
                                                             c_handleChange={c_handleChange}
                                                             change_c_photo={change_c_photo}
                                                             onCancel = {() => setIsEditProfile(false)} />
                }
            </div>
        </>

    )
}

export default ProfileCollectionList;